export default __webpack_public_path__ + "static/media/logo-min.a73c9ea0.svg";